"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _SimpleStyledClickable = _interopRequireDefault(require("./internal/SimpleStyledClickable"));

var _Functions = require("../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var UITextToolbarButton = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(UITextToolbarButton, _PureComponent);

  function UITextToolbarButton() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UITextToolbarButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UITextToolbarButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleClick = function (evt) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onSelectedChange = _this$props.onSelectedChange,
          selected = _this$props.selected;
      onSelectedChange((0, _SyntheticEvent.default)(!selected));
      (0, _Functions.callIfPossible)(onClick, evt);
    };

    return _this;
  }

  (0, _createClass2.default)(UITextToolbarButton, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          __onSelectedChange = _this$props2.onSelectedChange,
          selected = _this$props2.selected,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["onSelectedChange", "selected"]);
      return _react.default.createElement(_SimpleStyledClickable.default, Object.assign({}, rest, {
        "aria-pressed": selected,
        onClick: this.handleClick
      }));
    }
  }]);
  return UITextToolbarButton;
}(_react.PureComponent);

UITextToolbarButton.propTypes = {
  children: _propTypes.default.node,
  disabled: _propTypes.default.bool,
  onSelectedChange: _propTypes.default.func,
  selected: _propTypes.default.bool
};
UITextToolbarButton.defaultProps = {
  selected: false
};
UITextToolbarButton.displayName = 'UITextToolbarButton';

var _default = (0, _Controllable.default)(UITextToolbarButton, ['selected']);

exports.default = _default;
module.exports = exports.default;